module.exports = {"632525100":"茫曲镇","632525101":"过马营镇","632525102":"森多镇","632525200":"沙沟乡","632525202":"茫拉乡","632525203":"塔秀乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632525.json
// module id = 3145
// module chunks = 0